export enum CapAlertLevel {
  GLOBAL = 'global',
  CONTENT_HEADER = 'content-header'
}
